import React, { useState } from 'react';
import { Button, Row, Col, Card, CardBody, CardText, CardHeader } from 'reactstrap';
import { useHistory } from 'react-router-dom';

import createPulse from './engagement-pulse/createPulse';
import NewCheckInForm from './NewCheckInForm';
import WithLoader from './WithLoader';
import userService from './user/UserService';

const NoCheckInsCard = ({ onRefresh }) => (
  <Card>
    <CardHeader>
      <h5>You're All Caught Up!</h5>
    </CardHeader>
    <CardBody>
      <CardText>Looks like there isn't anything you need to do right now! Click refresh to check again.</CardText>
      <Button onClick={onRefresh} color="primary">Refresh</Button>
    </CardBody>
  </Card>
);

const Home = () => {
  const history = useHistory();

  const [checkIns, setCheckins] = useState([]);
  const [studentClasses, setStudentClasses] = useState([]);
  const [dysregulations, setDysregulations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchData = async done => {
    const hasProfile = await userService.hasProfile();
    if(!hasProfile) {
      history.push('/user/profile');
    } else {
      const [studentClasses, checkIns, dysregulations] = await Promise.all([userService.getClasses(), userService.getCheckIns(), userService.getDysregulationActivities()]);
      setStudentClasses(studentClasses);
      setCheckins(checkIns);
      setDysregulations(dysregulations);
      done();
    }
  };

  const fetchCheckIns = async () => {
    const checkIns = await userService.getCheckIns();
    setCheckins(checkIns);
  };

  const toggleNewCheckIn = () => setIsModalOpen(!isModalOpen);

  const createNewPulse = async () => {
    const pulseId = await createPulse();

    if(pulseId) {
        history.push(`/pulse/${pulseId}`);
    }
  }

  return (
    <WithLoader action={fetchData}>
      <Row className="justify-content-around">
        <Col sm="8" >
          {((checkIns?.length > 0 || dysregulations?.length > 0) ? (
            // todo - is studentName an accurate var name?
            // eric: no, I think an accurate name would be nameOfClass
            checkIns.map(({ checkInId, name: nameOfClass }) => (
              <Row>
                <Card style={{width:'100%'}}>
                  <CardHeader>
                    <h5>Pending Check In</h5>
                  </CardHeader>
                  <CardBody>
                    <CardText>Please check in for "{nameOfClass}"</CardText>
                    <Button 
                      onClick={e => history.push(`/check-ins/${e.target?.value}`)} 
                      value={checkInId} 
                      color="primary"
                    >
                      Check In
                    </Button>
                  </CardBody>
                </Card>
              </Row>
            )).concat(dysregulations.map(({checkInId, name: nameOfClass, createdOn}) => (
              <Row>
                <Card>
                  <CardHeader>
                    <h5>Dysregulated Response Needs Attention</h5>
                  </CardHeader>
                  <CardBody>
                    <CardText>There are dysregulation responses that have not been responded to from a check in for "{nameOfClass}" from {new Date(createdOn).toLocaleDateString('en-us')}.</CardText>
                    <Button 
                      onClick={e => history.push(`/check-ins/${e.target?.value}/summary`)} 
                      value={checkInId} 
                      color="primary"
                    >
                      View Check In
                    </Button>
                  </CardBody>
                </Card>
              </Row>
            )))
          ) : (
            <NoCheckInsCard onRefresh={fetchCheckIns} />
          ))}
        </Col>
        <Col sm="4">
          {studentClasses?.length > 0 && (
            <Card>
              <CardHeader>
                <h5>Assign a Check In</h5>
              </CardHeader>
              <CardBody>
                <CardText>Start a new check in for a class.</CardText>
                <Button onClick={toggleNewCheckIn} color="primary">Start Check In</Button>
              </CardBody>
            </Card>
          )}
          <Card>
            <CardHeader>
              <h5>Perform Engagement Pulse</h5>
            </CardHeader>
            <CardBody>
              <CardText>Start an engagement pulse.</CardText>
              <Button onClick={createNewPulse} color="primary">Start Pulse</Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <NewCheckInForm isOpen={isModalOpen} toggle={toggleNewCheckIn} />
    </WithLoader>
  );
}

export default Home;